import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { getModalContent } from "../../services/asiaService";
import LayoutModal from "../../layouts/Layout-Modal";
import LoadingSpinner from "../../elements/loading-spinner";
import { MODAL_ANI_TYPES } from "../../utils/modal-animations";
import SiteModal from "../../elements/site-modal";
import "./style.scss";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { changeModel } from "../../redux/actions/model";

const RouteModal = forwardRef(( props, ref) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [path, setPath] = useState(null);
  const [container, setContainer] = useState(null);
  const [routeData, setRouteData] = useState(false);
  const { changeModel, page } = props;
  const layoutProps = !loading &&
    container &&
    routeData && {
      route: routeData.sitecore.route,
      path: path,
      lang: container.lang,
      server: container.server,
      match: container.match
    };
  const distory = ev => {
    document.body.style.overflowY = "auto";
    changeModel(false);
    setTimeout(v=>{
      document.getElementsByTagName("html")[0].scrollTop = 0;
    })
    setShow(false);
  }
  useEffect( () => {
    return distory
  },[page]);
  const onCloseClick = () => {
    setShow(false);
    changeModel(false);
    document.body.style.overflowY = "auto";
  };
  useImperativeHandle(ref, () => ({
    async open(_path, _container) {
      if (show) return;
      setShow(true);
      changeModel(true);
      setLoading(true);
      setPath(_path);
      setContainer(_container);
      const lang = _container.lang ?? webStorage.get(S_LANG) ?? "en";
      const _routeData = await getModalContent(_path, lang);
      setRouteData(_routeData);
      setLoading(false);
      document.body.style.overflowY = "hidden";
    }
  }));
  return (
    <SiteModal className={classNames("route-modal", { loading })} open={show} animation={MODAL_ANI_TYPES.bottomFadeIn}>
      {loading && <LoadingSpinner />}
      {layoutProps && <LayoutModal {...layoutProps} />}
      <i className="route-modal__close" onClick={onCloseClick} >×</i>
    </SiteModal>
  );
});
const mapDispatchToProps = {
  changeModel: changeModel,
};
RouteModal.displayName = "routeModal";
export default connect(null, mapDispatchToProps, null, { forwardRef: true })(RouteModal);
